export default __webpack_public_path__ + "static/media/SFProTextR.7321ae2d.woff";